import $ from 'jquery'
import async from 'async'
import util from 'util'
import _ from 'lodash'

let _p = window.xwCommon,
	_this = {
		title:"城市地区选择",
		props:{ label:"name", value:"id", children:"childrens" },
		getProvinceList(vm){
			let u = _p.getApiUrl("address/province"),storeList = _p.getStoredProp("_/cityCache/province"),func = (callback, reject) => {
				if(!_p.isNull(storeList)){
					//console.log("checked",storeList)
					return callback(_p.clone(storeList))
				}

				$.get(u,(json) => {
	  				let status = parseInt(json.status)
	  				if(200 !== status){
	  					switch(status){
				            default: 
				              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
				              else reject(new Error(json.msg))
				              break;
				        }
				        return;
	  				}else{
	  					let provList = _p.clone(json.data)

	  					//console.log(provList)

	  					storeList = provList.map(( item ) => {
		                	return $.extend({childrens:[]},item)
		              	})

	  					_p.setStoredProp("_/cityCache/province",storeList)
	  					return callback(storeList)
	  				}
	  			})
			}
  			return new Promise(func)
		},
		getCitys(pid){
			let u = _p.getApiUrl("address/city"),storeList = _p.getStoredProp("_/cityCache/city_"+pid),
				func = (cb, reject) => {
					if(!_p.isNull(storeList)){
						return cb(_p.clone(storeList))
					}
					$.get(u,{pid},(json) => {
			      		let status = parseInt(json.status)
			      		if(200 !== status){ reject(json) }
			      		else{ 
			      			let data = _p.clone(json.data)
			      			_p.setStoredProp("_/cityCache/city_"+pid,data)
			      			cb(data) 
			      		}
			      	})
				}
			return new Promise(func)
		},
		getDistricts(pid){
			let u = _p.getApiUrl("address/district"),storeList = _p.getStoredProp("_/cityCache/district_"+pid),
				func = (cb, reject) => {
					$.get(u,{pid},(json) => {
			      		let status = parseInt(json.status)
			      		if(200 !== status){ reject(json) }
			      		else{ 
			      			let data = json.data
			      			_p.setStoredProp("_/cityCache/district_"+pid,data)
			      			cb(data) 
			      		}
			      	})
				}
			return new Promise(func)
		},
		getCityList(vm,pid,type){
			console.log(vm.cities)
			let target = vm.cities.list.find((item) => {
	      		return pid == item.id
	      	})
	      	//console.log(pid,target)
			if(target["childrens"] && target.childrens.length > 1 ){
				return;
			}
			_this.getCitys(pid).then((arr) => {
				let data = arr.map((o) => {
						return (type === 2) ? $.extend({childrens:[]},o):o
					})
				_this.fillCityList(vm, pid, data, type > 0)
			},(json) => {
				switch(status){
		            default: 
		              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
		              vm.$alert(json.msg,_this.title);
		              break;
		        }
			})

	    },
	    parseAddr(vm,str){
			let arr = /(\D*)\((\d{6})\)([\D\da-zA-Z\-_]*)/.exec(str)
			// 福建福州(350011)地址地址地址56L565756地址
			if(arr && arr.length > 3){
				let addr = arr[3], cityId = _this.getAddrValue(vm,arr[2])
				return { cityId, addr }
			}else{
				return { addr:str }
			}
		},
	    getDistrictList(vm,val){
	    	let cid = val[1], pid = val[0],
	    		targetP = vm.cities.list.find((item) => {
		      		return pid == item.id
		      	}),
	    		ecb = (json) => {
					switch(status){
			            default: 
			              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
			              vm.$alert(json.msg,_this.title);
			              break;
			        }
				}

			if(targetP.childrens && targetP.childrens.length > 1 ){
				let target = targetP.childrens.find((item) => {
		      		return cid == item.id
		      	})
		      	if(target.childrens && target.childrens.length > 0){
		      		return;
		      	}else{
		      		_this.getDistricts(cid).then((arr) => {
						_this.fillDistrictList(vm, pid, cid, arr)
					}).catch(ecb)
					return;
		      	}
			}

			_this.getCitys(pid).then((arr) => {
				let data = arr.map((o) => {
						return $.extend({childrens:[]},o)
					})
				_this.fillCityList(vm, pid, data, true)

				_this.getDistricts(cid).then((arr) => {
					_this.fillDistrictList(vm, pid, cid, arr)
				}).catch(ecb)
			}).catch(ecb)
	    },
	    fillDistrictList(vm,pid,cid,items){
	    	let targetP = vm.cities.list.find((item) => {
	      		return pid == item.id
	      	}), target = targetP.childrens.find((item) => {
	      		return cid == item.id
	      	})

	      	target.childrens = items
	    },
	    fillCityList(vm,pid,cities,addArea){
	      	let target = vm.cities.list.find((item) => {
	      		return pid == item.id
	      	}),arr = [];
	        arr.push({"id":pid,"name":"全区域","disabled":addArea})
	        target.childrens = arr.concat(cities)
	    },
	    parseCityId(cityId){
	    	let province_id = 0, city_id = undefined
	    	switch(cityId.length){
	    		case 2:
	    			city_id = cityId[1];
	    		case 1:
	    			province_id = cityId[0];
	    			break;
	    		default:
	    			break;
	    	}
	    	return { province_id,city_id }
	    },
	    getCityValue(vm,pid,cid){
	    	if(cid) _this.getCityList(vm,pid,1)
	    	return _this.toCityId(pid,cid)
	    },
	    getAddrValue(vm,did,type){
	    	did = did.toString()
	    	let trimSix = (val) =>{
	    		return parseInt((val+"000000").substr(0,6))
	    	},pid = trimSix(did.substr(0,2)),
	    	cid = trimSix(did.substr(0,4))

	    	did = parseInt(did)
	    	if(0 !== did%1e2) _this.getDistrictList(vm,[pid,cid])
	    	else if(0 !== did%1e4) _this.getCityList(vm,pid,type)
	    	
	    	return _this.toCityId(pid,cid,did)
	    },
	    toCityId(pid,cid,did){
	    	if(did)
	    		return [pid,cid,did]
	    	else
	    		return [pid,cid]
	    },
	    toCityName(vm,cityId){
	    	let name = "", code = "", arr = [],
	    		func = (arr,id) => {
	    			if(_p.isNull(arr)) return "";
	    			let val = arr.find((o) => {
	    				return id == o.id
	    			})
	    			return val
	    		}
	    	$.each(cityId,(k, v) => {
	    		if(_p.isNull(v)) return false;
	    		else arr.push(v)
	    	})
	    	switch(arr.length){
	    		case 1:
					{
		    			let objP = func(vm.cities.list,arr[0])
		    			name = objP.name
		    			code = objP.id
	    			}
	    			break;
	    		case 2:
					{
		    			let objP = func(vm.cities.list,arr[0]),
		    				objC = func(objP.childrens,arr[1])
		    			name = objP.name+objC.name
		    			code = objC.id
	    			}
	    			break;
	    		case 3:
	    			{
		    			let objP = func(vm.cities.list,arr[0]),
		    				objC = func(objP.childrens,arr[1]),
		    				objD = func(objC.childrens,arr[2])
		    			name = objP.name+objC.name+objD.name
		    			code = objD.id
	    			}
	    			break;
	    		default:
	    			return "";

	    	}
	    	return util.format("%s(%s)",name,code)
	    }
	}

export default _this


// WEBPACK FOOTER //
// ./src/lib/common/cityChoser.js